import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { EmployeeLookup } from '../Models/EmployeeLookup';
import { Router } from '@angular/router';
import { QuestionProcessingService } from '../services/question-processing.service';
import { BaseComponent } from '../Models/BaseComponent';
import { NotificationService } from '../services/notification.service';
import { PlacesService } from '../services/places.service';
import { Address } from '../Models/Address';
import { TouchEventService } from '../services/touch-event.service';
import { IntegrationService } from '../services/integration.service';
import { DynamicQuestionService } from '../services/dynamic-question.service';
import { Screening } from '../Models/Screening';


@Component({
  selector: 'app-employee-search',
  templateUrl: './employee-search.component.html',
  styleUrls: ['./employee-search.component.css']
})
export class EmployeeSearchComponent extends BaseComponent implements OnInit {

  @ViewChild('redirectForm') redirectForm:ElementRef;
  @ViewChild('isTaxCreditInput') isTaxCreditInput:ElementRef;
  @ViewChild('isCreditInput') isCreditInput:ElementRef;
  @ViewChild('taxBreakGuidInput') taxBreakGuidInput:ElementRef;
  @ViewChild('optedOutInput') optedOutInput:ElementRef;
  @ViewChild('returnCodeInput') returnCodeInput:ElementRef;

  location : Router;
  lookup : EmployeeLookup;
  _notes : NotificationService;
  validationText : string;

  states: string[] = ['AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN',
  'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'WY']
 

  constructor(location : Router, public question: DynamicQuestionService, public places : PlacesService, public swiper : TouchEventService, private integration : IntegrationService) { 
    super(swiper,location);
    this.validationText = '';
    if(!question.screening) {
      question.screening = new Screening();
      question.screening.demographics = new EmployeeLookup();
    }
    if (this.integration.payload) {
      let p = this.integration.payload;
      question.screening.demographics.FirstName = p.firstName;
      question.screening.demographics.LastName = p.lastName;
      question.screening.demographics.Email = p.email;
    }
    if (this.integration.integrationProfile) {
      let i = this.integration.integrationProfile;
      question.screening.integrationProfile=i;
      question.screening.demographics.FirstName=i.firstName;
      question.screening.demographics.LastName=i.lastName;
      question.screening.demographics.Email=i.email;
      question.screening.demographics.Address=new Address();
      question.screening.demographics.Address.StreetAddress=i.address1;
      question.screening.demographics.Address.City=i.city;
      question.screening.demographics.Address.State=i.state;
      question.screening.demographics.Address.Zip=i.zip;   
    }
  }

  ngOnInit() {
  }
  
  continue(){
    this.validationText = '';
    this.validationError = false;
    console.log(this.question.screening.demographics);
    //validate the specified values
    let phoneRegex : RegExp = new RegExp('^[0-9]{3}-[0-9]{3}-[0-9]{4}$');
    //regex sampled from http://emailregex.com/
    let emailRegex : RegExp = new RegExp('^[a-zA-Z0-9!#$%&\'*-/=?^_`{|}~]{1,}@[a-zA-Z0-9!#$%&\'*-/=?^_`{|}~]{1,}\.[a-zA-Z0-9]{2,}$');
    let ssnRegex : RegExp = new RegExp('^[0-9]{3}-[0-9]{2}-[0-9]{4}$');
    // console.log('test', phoneRegex.test(this.question.screening.demographics.PhoneNumber));
    if(this.question.screening.demographics.FirstName == undefined || 
      this.question.screening.demographics.FirstName == "" || 
      this.question.screening.demographics.LastName == "" ||
      this.question.screening.demographics.LastName == undefined) {
      this.validationError = true;
      this.validationText += 'Please enter your first and last name. '
    } 
    if(this.question.screening.demographics.PhoneNumber == undefined || 
      this.question.screening.demographics.PhoneNumber.replace('-','').replace('-','').length != 10) {
      this.validationError = true;
      this.validationText += 'Please enter a ten digit phone number. '
    }
    if (this.question.screening.demographics.Email == undefined || !emailRegex.test(this.question.screening.demographics.Email)) {
      this.validationError = true;
      this.validationText += 'Please enter a valid email address. ';
    }
    if (this.question.screening.demographics.SSN == undefined || !ssnRegex.test(this.question.screening.demographics.SSN)) {
      this.validationError = true;
      this.validationText += 'Please enter a valid social security number. ';
    } 
    if(!this.validationError) {
      this.location.navigateByUrl('surveySingle');
    }
  }

  formatPhone() : void {
    if(this.question.screening.demographics.PhoneNumber.length == 3) this.question.screening.demographics.PhoneNumber += '-';
    if(this.question.screening.demographics.PhoneNumber.length == 7) this.question.screening.demographics.PhoneNumber += '-';
  } 

  formatSSN() : void {
    if(this.question.screening.demographics.SSN.length == 3) this.question.screening.demographics.SSN += '-';
    if(this.question.screening.demographics.SSN.length == 6) this.question.screening.demographics.SSN += '-';
  }

  help() : void {
    console.log("Sample Tooltip!");
  }

  optout() : void {
    if (this.integration.integrationProfile.returnUrl!=null)
    {
      this.isTaxCreditInput.nativeElement.value=false;
      this.isCreditInput.nativeElement.value=false;
      this.taxBreakGuidInput.nativeElement.value=this.integration.integrationProfile.taxBreakGUID;
      this.optedOutInput.nativeElement.value=true;
      this.returnCodeInput.nativeElement.value="";
      this.redirectForm.nativeElement.action=this.integration.integrationProfile.returnUrl;
      this.redirectForm.nativeElement.submit();
    }
  }

}



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/employee-search/employee-search.component.ts